<h1>Bildgenaue Navigation in der Zeitleiste</h1>
<section class="article">
    <article>
        <div class="text">
            <p>
                Insbesondere bei längeren Clips ist die genaue Positionierung auf ein bestimmtes
                Bild mit der Maus schwierig. Zu diesem Zweck musste man bisher in die Zeitleiste
                hineinzoomen, um die einzelnen Bilder ansteuern zu können. 
                Version 2.3 hat zu diesem Zweck neue Schaltflächen und Tastaturkürzel bekommen.
            </p>
            <img src="assets/navigation_tools.png" style="width: 600px;" />
            <table style="width: 100%; margin-top: 20px;">
                <tr>
                    <th>Schaltfläche</th>
                    <th>Funktion</th>
                    <th>Tastaturkürzel</th>
                </tr>
                <tr>
                    <td><img src="assets/one_step_left.png" /></td>
                    <td>Cursor ein Bild nach links navigieren</td>
                    <td>Strg + Umschalt + Links</td>
                </tr>
                <tr>
                    <td><img src="assets/one_step_right.png" /></td>
                    <td>Cursor ein Bild nach rechts navigieren</td>
                    <td>Strg + Umschalt + Rechts</td>
                </tr>
                <tr>
                    <td><img src="assets/set_clip_start.png" /></td>
                    <td>Startposition des Clips setzen</td>
                    <td>Strg + Umschalt + Pos1</td>
                </tr>
                <tr>
                    <td><img src="assets/set_clip_end.png" /></td>
                    <td>Endposition des Clips setzen</td>
                    <td>Strg + Umschalt + Ende</td>
                </tr>
            </table>
            <p>
            </p>
        </div>
    </article>
</section>
